module.exports = __webpack_public_path__ + "static/media/mode-520.443eb905.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-520.svg
// module id = 1045
// module chunks = 2